const domain = 'User';

export default domain;
